import React, { FC } from 'react'
import { i18n, IconComponent } from 'LibNeo'
import '../../../styles/successMessage.scss'

type ComponentProps = {
	subTitle: string
	orderId: number
	isDraft?: boolean
}

export const SuccessMessageForModalComponent: FC<ComponentProps> = ({
	subTitle,
	orderId,
	isDraft,
}) => {
	return (
		<div className="success_message-container">
			<IconComponent name="check-checked" className="success_message-container__icon" />
			<div>
				<div className="success_message-container__text">
					{isDraft ? 'Заявка отправлена в банк.' : `Заявка №${orderId} создана!`}
				</div>

				<div className="success_message-container__text">{i18n(subTitle)}</div>
			</div>
		</div>
	)
}
